import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants/index';




/*

Props:

*/

const StyledDiv = styled.div`

    width: 100%;
    max-height: ${props => props.maxHeight ? props.maxHeight : '110px'};
    overflow: scroll;
    margin-bottom: ${props => props.conditionalScrollCount > 1 ? 15 : 'none'};
    box-shadow: ${props => props.conditionalScrollCount > 1 ? 'rgba(0, 0, 0, 0.38) 0px -16px 20px -20px inset' : 'none'};
    border-top: ${props => props.conditionalScrollCount > 1 ? '2px solid lightgrey' : 'none'};
    border-bottom: ${props => props.conditionalScrollCount > 1 ? '2px solid lightgrey' : 'none'};


`;


const ConditionalScrollList  = ({ style, children, ...rest }) => (
    <StyledDiv style = {style} {...rest} >
        { children }
    </StyledDiv>

);



export default ConditionalScrollList ;


// WEBPACK FOOTER //
// ./src/js/components/Lists/ConditionalScrollList.jsx